<ng-container *ngIf="showBloqueDestacados">
  <app-bloque-destacados [configPrensa]="configPrensa"></app-bloque-destacados>
</ng-container>
<app-common-menu-burguer [resizable]="resizable" [configPrensa]="configPrensa"></app-common-menu-burguer>

<div class="header-movil">
  <app-header-movil [configPrensa]="configPrensa"></app-header-movil>
</div>

<div class="header-desktop">
  <app-home-nav-menu [resizable]="resizable" [configPrensa]="configPrensa"></app-home-nav-menu>
  <app-logo-menu [configPrensa]="configPrensa"></app-logo-menu>
  <app-secondary-menu [resizable]="resizable" [configPrensa]="configPrensa"></app-secondary-menu>
</div>
